import shopsApi from '@/api/shops'

export default {
  namespaced: true,

  state: () => ({
    shops: [],
    currentShop: null,
    activeShopId: localStorage.getItem('mob_active_shop') || null,
    loading: false
  }),

  getters: {
    shops: s => s.shops,
    currentShop: s => s.currentShop,
    activeShopId: s => s.activeShopId,
    loading: s => s.loading
  },

  mutations: {
    SET_SHOPS (state, shops) { state.shops = shops },
    SET_CURRENT (state, shop) { state.currentShop = shop },
    SET_LOADING (state, val) { state.loading = val },
    SET_ACTIVE_SHOP (state, shopId) {
      state.activeShopId = shopId
      if (shopId) localStorage.setItem('mob_active_shop', shopId)
      else localStorage.removeItem('mob_active_shop')
    },
    ADD_SHOP (state, shop) { state.shops.unshift(shop) },
    UPDATE_SHOP (state, updated) {
      const i = state.shops.findIndex(s => s.shopId === updated.shopId)
      if (i !== -1) state.shops.splice(i, 1, updated)
    }
  },

  actions: {
    async fetchOwnerShops ({ commit, rootGetters }) {
      commit('SET_LOADING', true)
      try {
        const userId = rootGetters['auth/userId']
        const { data } = await shopsApi.getByOwner(userId)
        commit('SET_SHOPS', data)
        return data
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async fetchShop ({ commit }, shopId) {
      const { data } = await shopsApi.getById(shopId)
      commit('SET_CURRENT', data)
      return data
    },

    async createShop ({ commit }, payload) {
      const { data } = await shopsApi.create(payload)
      commit('ADD_SHOP', data)
      return data
    },

    async updateShop ({ commit }, { shopId, payload }) {
      const { data } = await shopsApi.update(shopId, payload)
      commit('UPDATE_SHOP', data)
      return data
    }
  }
}
